export default "/images/check.svg"